import { createDateFromSeconds } from "../../../helpers/createDateFromSeconds";
import "./ApplicationCard.css";
import ApplicationCardButton from "./ApplicationCardButton";

function ApplicationCard({ applicationData }) {
  if (
    !applicationData ||
    !applicationData.congressName ||
    !applicationData.publicationDate
  )
    return null;

  return (
    <div className="application-card-wrapper">
      <div className="application-card">
        <p className="publication-date">
          {createDateFromSeconds(applicationData.publicationDate.seconds)}
        </p>

        <h2 className="application-title">
          Pályázati felhívás: {applicationData.congressName}
        </h2>

        <ApplicationCardButton to={`/application/${applicationData.id}`} />
      </div>
    </div>
  );
}

export default ApplicationCard;
